/**
 * 理疗模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取理疗列表(过滤掉已被禁用的理疗项目)
export const physioList = (params) => {
  return req.get('/hosp/physio/list', params);
}

// 获取理疗列表(所有理疗项目)
export const physioListAll = (params) => {
  return req.get('/hosp/physio/listNew', params);
}

// 获取理疗类型列表
export const physioKindList = (params) => {
  return req.get('/hosp/physio/kind/list', params);
}

// 获取理疗类型列表
export const changeEnableStatus = (params) => {
  return req.post('/hosp/physio/editEnableStatus', params);
}

// 根据药品种类查询药品
export const physioListDetails = (params) => {
  return req.get('/hosp/physio/selectListByKindId', params);
}
// 根据药品种类查询药品
export const edit = (params) => {
  return req.post('/hosp/physio/edit', params);
}
// 获取理疗执行周期
export const getPhysioIntervalEnum = (params) => {
  return req.get('/hosp/physio/getPhysioIntervalEnum', params);
}
//校验理疗项目必填项
export const checkPhysioConfig = (params) => {
  return req.post('/hosp/physio/checkPhysioConfig', params);
}

